import * as styles from './BoardSwitcherTilesLoadingSkeleton.module.less';

export const BoardSwitcherTilesLoadingSkeleton = () => {
  return (
    <div className={styles.skeletonBoardTilesWrapper}>
      <div className={styles.skeletonBoardTile}></div>
      <div className={styles.skeletonBoardTile}></div>
      <div className={styles.skeletonBoardTile}></div>
      <div className={styles.skeletonBoardTile}></div>
    </div>
  );
};
